import { render, staticRenderFns } from "./StorySection.htm?vue&type=template&id=1247d7fb&scoped=true&external"
import script from "./StorySection.js?vue&type=script&lang=js&external"
export * from "./StorySection.js?vue&type=script&lang=js&external"
import style0 from "./StorySection.scss?vue&type=style&index=0&id=1247d7fb&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1247d7fb",
  null
  
)

export default component.exports